export default __webpack_public_path__ + "static/media/logo-enviar.1900b5fb.svg";